import React from "react";

const SignUpContext = React.createContext({
  registrationId: undefined,
  setRegistrationId: (id) => {},
  credentials: undefined,
  setCredentials: (arg) => {},
});

export default SignUpContext;
